export default __webpack_public_path__ + "static/media/sign-white.bf617572.svg";